import { money } from "./format";

// Low–estimate–high price-range bar. Pure CSS/inline (no charting lib). Renders
// nothing if there's no usable low/high range.
export default function RangeBar({ low, high, estimate }) {
  if (!low || !high || high <= low) return null;

  const clamp = (n) => Math.max(0, Math.min(100, n));
  const markerPct = estimate ? clamp(((estimate - low) / (high - low)) * 100) : 50;

  return (
    <div style={{ marginTop: "1.25rem" }}>
      <div
        style={{
          position: "relative",
          height: 8,
          borderRadius: 999,
          background: "linear-gradient(90deg, var(--ss-connect-accent), var(--ss-connect-primary))",
        }}
      >
        <span
          aria-hidden="true"
          style={{
            position: "absolute",
            top: "50%",
            left: `${markerPct}%`,
            transform: "translate(-50%, -50%)",
            width: 18,
            height: 18,
            borderRadius: "50%",
            background: "#fff",
            border: "3px solid var(--ss-connect-primary)",
            boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
          }}
        />
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", marginTop: "0.4rem", fontSize: "0.85rem", color: "var(--ss-connect-text-muted)" }}>
        <span>{money(low)}</span>
        <span>{money(high)}</span>
      </div>
    </div>
  );
}
